import { useContext } from 'react';
import { CANvisionContext, CANvisionContextValue } from './CANvisionContext';

/**
 * Convenience hook to consume the CANvision shared context.
 *
 * Throws a descriptive error when called outside of `<CANvisionProvider>` so
 * that missing-provider bugs surface immediately during development.
 *
 * @example
 * ```tsx
 * const { sites, selectedSiteId, setSelectedSiteId } = useCANvisionContext();
 * ```
 */
export function useCANvisionContext(): CANvisionContextValue {
  const context = useContext(CANvisionContext);

  if (context === undefined) {
    throw new Error(
      'useCANvisionContext must be used within a <CANvisionProvider>. ' +
        'Wrap your component tree with <CANvisionProvider> before calling this hook.',
    );
  }

  return context;
}
